import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { type GetAllCasesForProfileQuery } from "~/graphql/supergraphTypes";

export type RelatedCase = NonNullable<
  NonNullable<
    GetAllCasesForProfileQuery["complianceProfile"]
  >["activeCases"][number]["complianceCase"]
>;

export const getRelatedCases = (
  data: GetAllCasesForProfileQuery | undefined,
  currentCaseId: number,
): RelatedCase[] => {
  const rows = data?.complianceProfile?.activeCases ?? [];
  return rows
    .map((row) => row?.complianceCase)
    .filter(
      (c): c is RelatedCase =>
        c != null && c.id !== currentCaseId && c.caseType !== ComplianceCaseTypeEnum.Escalation,
    );
};
